import auth from '@/middlewares/auth';
import guest from '@/middlewares/guest';
import { userRoutes } from '@/routes/users/userRoutes';
import { ticketRoutes } from '@/routes/users/ticketRoutes';
import { companyRoutes } from '@/routes/users/companyRoutes';
import { contactRoutes } from '@/routes/users/contactRoutes';
import { supportRequestRoutes } from '@/routes/users/supportRequestRoutes';
import { chatSettingsRoute } from '@/routes/setting/chatSettingsRoute';
import { otherRoutes } from '@/routes/setting/otherRoutes';
import { groupRoutes } from '@/routes/setting/groupRoutes';
import { supportRequestTypeRoutes } from '@/routes/setting/supportRequestTypeRoutes';
import { customerRoutes } from '@/routes/customer/customerRoutes';
import { inventoryRoutes } from '@/routes/inventory/inventoryRoutes';
import { typeRoutes } from '@/routes/inventory/typeRoutes';
import { brandRoutes } from '@/routes/inventory/brandRoutes';
import { locationRoutes } from '@/routes/inventory/locationRoutes';
import { nameRoutes } from '@/routes/inventory/nameRoutes';
import { domainRoutes } from '@/routes/inventory/domainRoutes';
import { licenseRoutes } from '@/routes/inventory/licenseRoutes';
import { sslRoutes } from '@/routes/inventory/sslRoutes';
import { wowzaLicenseRoutes } from '@/routes/inventory/wowzaLicenseRoutes';
import { leaveRequestRoutes } from '@/routes/hr/leaveRequestRoutes';
import { leaveRoutes } from '@/routes/hr/leaveRoutes';
import { workingScheduleRoutes } from '@/routes/hr/workingScheduleRoutes';
import { scheduleRoutes } from '@/routes/hr/scheduleRoutes';
import { shiftRoutes } from '@/routes/hr/shiftRoutes';

let routes = [
  {
    path: '/login',
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/auth/Login'),
    name: 'login',
    meta: {
      middleware: [guest],
    },
  },
  {
    path: '/',
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '../views/Dashboard'),
    name: 'dashboard',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/403',
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '../views/errorPages/403.vue'),
    name: '403',
  },
];

routes.push(...userRoutes);
routes.push(...ticketRoutes);
routes.push(...companyRoutes);
routes.push(...contactRoutes);
routes.push(...supportRequestRoutes);
routes.push(...chatSettingsRoute);
routes.push(...otherRoutes);
routes.push(...groupRoutes);
routes.push(...supportRequestTypeRoutes);
routes.push(...customerRoutes);
routes.push(...inventoryRoutes);
routes.push(...typeRoutes);
routes.push(...brandRoutes);
routes.push(...locationRoutes);
routes.push(...nameRoutes);
routes.push(...domainRoutes);
routes.push(...licenseRoutes);
routes.push(...sslRoutes);
routes.push(...wowzaLicenseRoutes);
routes.push(...leaveRequestRoutes);
routes.push(...leaveRoutes);
routes.push(...workingScheduleRoutes);
routes.push(...scheduleRoutes);
routes.push(...shiftRoutes);

export default routes;
